import React, { useState } from "react";
import "./styles.scss";

import Button from "../../../common/button";
import Input from "../../../common/Input";
import { FormControlLabel, Checkbox, InputLabel } from "@mui/material";
import { TextField, Autocomplete } from "@mui/material";

import { ReactComponent as FilledIcon } from "../../../assets/icons/filledCheckbox.svg";
import { ReactComponent as UnFilledIcon } from "../../../assets/icons/unfilledCheckbox.svg";
import { useStateValue } from "../../../store";
import SkeletonLine from "../../../common/Skeletion/line";

const ShippingInfo = ({
  handleUpdate,
  setShippingData,
  shippingData,
  statetrigger,
}) => {
  const [{ countryList, stateList, shippingMethod }, dispatch] =
    useStateValue();
  const [inputValidation, setInputValidation] = useState({
    shipping_first_name: "",
    shipping_last_name: "",
    shipping_phone_number: "",
    shipping_address_1: "",
    shipping_address_2: "",
    shipping_postal_zip: "",
    shipping_city: "",
    shipping_country: "",
    shipping_state: "",
  });

  //change input
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    setShippingData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setInputValidation((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  // validation
  const handleValidateInput = () => {
    var errorHandle = false;
    if (!shippingData?.shipping_first_name) {
      document.getElementById("shipping_first_name")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_first_name: "Please enter the first name.",
      }));
      errorHandle = true;
    }
    if (!shippingData?.shipping_last_name) {
      document.getElementById("shipping_last_name")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_last_name: "Please enter the last name.",
      }));
      errorHandle = true;
    }
    if (!shippingData?.shipping_phone_number) {
      document.getElementById("shipping_phone_number")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_phone_number: "Please enter the phone number.",
      }));
      errorHandle = true;
    } else if (
      shippingData?.shipping_phone_number?.length < 6 ||
      shippingData?.shipping_phone_number?.length > 15
    ) {
      document.getElementById("shipping_phone_number")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_phone_number:
          "Please enter more than 6 and less than 16 digit phone number.",
      }));
      errorHandle = true;
    }
    if (!shippingData?.shipping_address_1) {
      document.getElementById("shipping_address_1")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_address_1: "Please enter the address line 1.",
      }));
      errorHandle = true;
    }
    if (!shippingData?.shipping_address_2) {
      document.getElementById("shipping_address_2")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_address_2: "Please enter the address line 2.",
      }));
      errorHandle = true;
    }
    if (!shippingData?.shipping_postal_zip) {
      document.getElementById("shipping_postal_zip")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_postal_zip: "Please enter the postal zip.",
      }));
      errorHandle = true;
    }
    if (!shippingData?.shipping_city) {
      document.getElementById("shipping_city")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_city: "Please enter the town/city.",
      }));
      errorHandle = true;
    }
    if (!shippingData?.shipping_country) {
      document.getElementById("shipping_country")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_country: "Please enter the country/region.",
      }));
      errorHandle = true;
    }
    if (
      !shippingData?.shipping_state &&
      !shippingData?.shipping_state?.state_name &&
      stateList?.is_input_box
    ) {
      document.getElementById("shipping_state")?.focus();
      setInputValidation((prevState) => ({
        ...prevState,
        shipping_state: "Please enter or choose the province/state.",
      }));
      errorHandle = true;
    }

    if (!errorHandle) {
      handleUpdate();
    }
  };

  return (
    <div className="shipping-container">
      <div className="input-section">
        <p>First name</p>
        <Input
          placeholder="Enter first name"
          value={shippingData?.shipping_first_name}
          id="shipping_first_name"
          name="shipping_first_name"
          type="text"
          onChange={onHandleChange}
        />
        {inputValidation?.shipping_first_name && (
          <InputLabel className="validation_error">
            {inputValidation?.shipping_first_name}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p>Last name</p>
        <Input
          placeholder="Enter last name"
          value={shippingData?.shipping_last_name}
          name="shipping_last_name"
          id="shipping_last_name"
          type="text"
          onChange={onHandleChange}
        />
        {inputValidation?.shipping_last_name && (
          <InputLabel className="validation_error">
            {inputValidation?.shipping_last_name}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p>Phone number</p>
        <Input
          placeholder="Enter phone number"
          value={shippingData?.shipping_phone_number}
          name="shipping_phone_number"
          id="shipping_phone_number"
          type="number"
          onChange={onHandleChange}
        />
        {inputValidation?.shipping_phone_number && (
          <InputLabel className="validation_error">
            {inputValidation?.shipping_phone_number}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p>
          Company name <span className="optional"> (optional)</span>
        </p>
        <Input
          placeholder="Enter company name"
          value={shippingData?.shipping_company_name}
          name="shipping_company_name"
          id="shipping_company_name"
          type="text"
          onChange={onHandleChange}
        />
      </div>
      <div className="input-section">
        <p>Street address</p>
        <Input
          placeholder="Address line 01"
          value={shippingData?.shipping_address_1}
          name="shipping_address_1"
          id="shipping_address_1"
          type="text"
          onChange={onHandleChange}
        />
        {inputValidation?.shipping_address_1 && (
          <InputLabel className="validation_error">
            {inputValidation?.shipping_address_1}
          </InputLabel>
        )}
        <Input
          placeholder="Address line 02"
          style={{ marginTop: "16px" }}
          value={shippingData?.shipping_address_2}
          name="shipping_address_2"
          id="shipping_address_2"
          type="text"
          onChange={onHandleChange}
        />
        {inputValidation?.shipping_address_2 && (
          <InputLabel className="validation_error">
            {inputValidation?.shipping_address_2}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p>Postal zip</p>
        <Input
          placeholder="Enter postal zip"
          value={shippingData?.shipping_postal_zip}
          name="shipping_postal_zip"
          type="text"
          id="shipping_postal_zip"
          onChange={(e) => {
            dispatch({
              type: "SET_IS_SERVICE_POPUP",
              value: false,
              data: null,
              apiData: "",
            });
            onHandleChange(e);
          }}
        />
        {inputValidation?.shipping_postal_zip && (
          <InputLabel className="validation_error">
            {inputValidation?.shipping_postal_zip}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p>Town / City</p>
        <Input
          placeholder="Enter town/city"
          value={shippingData?.shipping_city}
          name="shipping_city"
          type="text"
          id="shipping_city"
          onChange={onHandleChange}
        />
        {inputValidation?.shipping_city && (
          <InputLabel className="validation_error">
            {inputValidation?.shipping_city}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p>Country / Region</p>
        <Autocomplete
          options={countryList}
          value={shippingData?.shipping_country}
          name="shipping_country"
          onChange={(event, newValue) => {
            setShippingData((prev) => ({
              ...prev,
              shipping_country: newValue,
              shipping_state: "",
            }));

            setInputValidation((prevState) => ({
              ...prevState,
              shipping_country: "",
            }));
          }}
          fullWidth
          getOptionLabel={(option) =>
            option.country_name ? option.country_name : ""
          }
          isOptionEqualToValue={(option, value) =>
            option?.country_id === value?.country_id
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label=""
              className="inputfield-box"
              placeholder="Select country/region"
              InputLabelProps={{
                shrink: false,
              }}
            />
          )}
        />
        {inputValidation?.shipping_country && (
          <InputLabel className="validation_error">
            {inputValidation?.shipping_country}
          </InputLabel>
        )}
      </div>
      {statetrigger ? (
        <SkeletonLine style={{ height: "4vh", margin: "2px" }} />
      ) : stateList && stateList?.data?.states?.length ? (
        <div className="input-section">
          <p>Province / State</p>
          <Autocomplete
            options={stateList?.data?.states || []}
            value={shippingData?.shipping_state || null}
            name="shipping_state"
            onChange={(event, newValue) => {
              setShippingData((prev) => ({
                ...prev,
                shipping_state: newValue,
              }));

              setInputValidation((prevState) => ({
                ...prevState,
                shipping_state: "",
              }));
            }}
            fullWidth
            getOptionLabel={(option) =>
              option?.state_name ? option?.state_name : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label=""
                className="inputfield-box"
                placeholder="Select province/state"
                InputLabelProps={{
                  shrink: false,
                }}
              />
            )}
          />
          {inputValidation?.shipping_state && (
            <InputLabel className="validation_error">
              {inputValidation?.shipping_state}
            </InputLabel>
          )}
        </div>
      ) : (
        <>
          {stateList?.is_input_box ? (
            <div className="input-section">
              <p>Province / State</p>
              <Input
                placeholder="Enter province/state"
                value={
                  shippingData?.shipping_state?.state_name
                    ? null
                    : shippingData?.shipping_state
                }
                name="shipping_state"
                id="shipping_state"
                type="text"
                onChange={onHandleChange}
              />
              {inputValidation?.shipping_state && (
                <InputLabel className="validation_error">
                  {inputValidation?.shipping_state}
                </InputLabel>
              )}
            </div>
          ) : null}
        </>
      )}
      {shippingMethod?.data?.shipping_method?.shipping_text && (
        <div className="input-section">
          <p>Shipping method</p>
          <FormControlLabel
            control={
              <Checkbox
                icon={<UnFilledIcon />}
                id="shipping_method"
                checked={true}
                checkedIcon={<FilledIcon />}
                inputProps={{ "aria-label": "controlled" }}
                disableRipple
              />
            }
            label={shippingMethod?.data?.shipping_method?.shipping_text}
          />
        </div>
      )}

      <div className="btn">
        <Button onClick={() => handleValidateInput()} disabled={statetrigger}>
          Proceed to payment
        </Button>
      </div>
    </div>
  );
};

export default ShippingInfo;
